import * as React from 'react';
import type { BookingStep } from '@bondvet/types/booking';
import useRestoreBookingSession from 'booking/hooks/useRestoreBookingSession';
import Loading from 'core/components/Loading';
import Booking from '../Booking';

type RestoreBookingSessionProps = {
    step: BookingStep;
};

export default function RestoreBookingSession({
    step,
    children,
}: React.PropsWithChildren<RestoreBookingSessionProps>) {
    const { isRestoring } = useRestoreBookingSession();

    if (isRestoring) {
        return <Loading label="loading details" />;
    }

    return <Booking step={step}>{children}</Booking>;
}
